<script>
import FontIcon from '@/components/FontIcon'
import { mapGetters } from 'vuex'

export default {
  name: 'MenuItem',
  components: { FontIcon },
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconType: {
      type: String,
      default: 'svg'
    },
    title: {
      type: String,
      default: ''
    },
    fontSize: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    ...mapGetters( ['size'] )
  },
  render(h, context) {
    const { icon, iconType, title, fontSize } = context.props
    const vnodes = []
    if (icon) {
      if (iconType === 'svg') {
        vnodes.push(<svg-icon icon-class={icon}/>)
      }
      else if (iconType === 'material') {
        vnodes.push(<FontIcon type='material-icons' name={icon} sclass='icon info' size={fontSize} sstyle="margin-left: 20px;"/>)
      }
    }

    if (title) {
      let className = 'labelfont-' + fontSize
      vnodes.push(<span slot='title' class={className}>{(title)}</span>)
    }
    return vnodes
  }
}
</script>
